import { createFetchThunk } from "../common/commonFetchThunk.js";
import { getQuickServiceApi } from "../../api/quickServiceApi/quick.api";

export const fetchQuickServices = createFetchThunk({
  typePrefix: "quickServices/fetch",
  apiFn: getQuickServiceApi,
  errorMessage: "Failed to fetch Quick Services",
});
